import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询环境列表
export const queryOutputEnvs: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setOutputEnvs', { ...state.envs, loading: true });
    // const res = await $http.get('/migration/output/environments');
    const res = await $http.get('/v1/migration/output/environments');
    commit('setOutputEnvs', { data: res });
  } catch (e) {
    commit('setOutputEnvs', { data: [] });
  }
};

// 查询专案列表
export const queryOutputDesigns: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOutputDesigns', { ...state.designs, loading: true });
    // const res: IPageData = await $http.post('/migration/output/list/design', payload);
    const res: IPageData = await $http.post('/v1/migration/output/list/design', payload);
    commit('setOutputDesigns', { data: res.list, total: res.total, pageSize: res.pageSize, pageNum: res.pageNum });
  } catch (e) {
    commit('setOutputDesigns', { data: [], total: 0, pageSize: 0, pageNum: 0 });
  }
};

// 查询专案展示列表
export const queryOutputDesignShows: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOutputDesignShows', { ...state.designShows, loading: true });
    const res: IPageData = await $http.post('/v1/migration/output/list/designshow', payload);
    commit('setOutputDesignShows', {
      data: res.list, total: res.total, pageSize: res.pageSize, pageNum: res.pageNum,
    });
  } catch (e) {
    commit('setOutputDesignShows', { data: [], total: 0, pageSize: 0, pageNum: 0 });
  }
};

// 查询样板间列表
export const queryOutputRooms: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOutputRooms', { ...state.rooms, loading: true });
    // const res: IPageData = await $http.post('/migration/output/list/blankroom', payload);
    const res: IPageData = await $http.post('/v1/migration/output/list/blankroom', payload);
    commit('setOutputRooms', { data: res.list, total: res.total, pageSize: res.pageSize, pageNum: res.pageNum });
  } catch (e) {
    commit('setOutputRooms', { data: [], total: 0, pageSize: 0, pageNum: 0 });
  }
};

// 查询地图列表
export const queryOutputMaps: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOutputMaps', { ...state.maps, loading: true });
    // const res: IPageData = await $http.post('/migration/output/map/list', payload);
    const res: IPageData = await $http.post('/v1/migration/output/map/list', payload);
    commit('setOutputMaps', { data: res.list, total: res.total, pageSize: res.pageSize, pageNum: res.pageNum });
  } catch (e) {
    commit('setOutputMaps', { data: [], total: 0, pageSize: 0, pageNum: 0 });
  }
};

// 查询静态贴图包列表
export const queryOutputPacks: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOutputPacks', { ...state.packages, loading: true });
    // const res: IPageData = await $http.post('/baseinfo/texturepackage/list', payload);
    const res: IPageData = await $http.post('/v1/ue/texture/list', payload);
    commit('setOutputPacks', {
      data: res.list, total: res.total, pageSize: res.pageSize, pageNum: res.pageNum,
    });
  } catch (e) {
    commit('setOutputPacks', { data: [], total: 0, pageSize: 0, pageNum: 0 });
  }
};

// 创建迁移任务
export const createOutputTask: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOutputResult', { data: null, loading: true });
    const { url, ...rest } = payload;
    const res = await $http.post(url, rest);
    commit('setOutputResult', { data: res });
  } catch (e) {
    commit('setOutputResult', { data: null });
  }
};
